import { render, staticRenderFns } from "./suppierManagementDeatils.vue?vue&type=template&id=7578caeb&scoped=true&"
import script from "./suppierManagementDeatils.vue?vue&type=script&lang=js&"
export * from "./suppierManagementDeatils.vue?vue&type=script&lang=js&"
import style0 from "./suppierManagementDeatils.vue?vue&type=style&index=0&id=7578caeb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7578caeb",
  null
  
)

export default component.exports